import { Avatar, List, Skeleton } from '@usepepper/sprout-kit-ui';

const TITLE_HEIGHT = 14;
const TITLE_WIDTH = 140;
const SUBTITLE_HEIGHT = 12;
const SUBTITLE_WIDTH = 180;

export const RestaurantOptionSkeleton = () => (
  <List.Item>
    <List.Item.Leading>
      <Avatar backgroundColor="$loaderSkeleton" initials="" size="$sm" />
    </List.Item.Leading>
    <List.Item.Content>
      <Skeleton height={TITLE_HEIGHT} width={TITLE_WIDTH} />
      <Skeleton height={SUBTITLE_HEIGHT} width={SUBTITLE_WIDTH} />
    </List.Item.Content>
  </List.Item>
);
